module.exports = __webpack_public_path__ + "static/img/twin-wateway-1.028f9104.png";